import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import type { Car } from '@/api/cars/types';
import { client } from '@/api/common';

type Variables = {};
type Response = Car[];

export const useCalendarCars = createQuery<Response, Variables, AxiosError>({
  queryKey: ['calendar/cars'],
  fetcher: () => {
    return client.get(`v2/internal/partners/cars/calendar`).then((response) => {
      return response.data.data;
    });
  },
});
